import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { IonMenu, Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { NavigationEnd, Router } from '@angular/router';
import { initializeApp } from 'firebase';
import { environment } from '../environments/environment';
import { SharedService } from './services/shared-service/shared.service';
import { AccountService } from './services/account/account.service';
import { UserDto } from './models/UserDto';
import { LogoutService } from './component-services/logout/logout.service';
import { Storage } from '@ionic/storage';

@Component({
	selector: 'app-root',
	templateUrl: 'app.component.html',
	styleUrls: ['app.component.scss']
})
export class AppComponent implements OnInit {
	@ViewChild('menu', { static: true }) menu: IonMenu;
	isSidebarCollapsed = false;
	isShowSideMenu: boolean = true;
	isCollaps: boolean = false;
	spinnerText: string = 'Loading...';
	loadingVisible: boolean = false;
	isAuthenticated: boolean = false;
	userDetails: UserDto;
	logoutpopover: boolean = false;
	menuItems = [
		{
			title: 'Areas',
			url: '/areas',
			icon: 'assets/svgs/areas/building-fill.svg',
			enabled: false
		},
		{
			title: 'Divisions',
			url: '/divisions',
			icon: 'assets/svgs/header/division.svg',
			enabled: false
		},
		{
			title: 'Lineitems',
			url: '/lineitems',
			icon: 'assets/svgs/header/lines.svg',
			enabled: false
		},
		{
			title: 'Trades',
			url: '/trades',
			icon: 'assets/svgs/header/trades.svg',
			enabled: false
		},
		{
			title: 'Keywords',
			url: '/keywords',
			icon: 'assets/svgs/header/keywords.svg',
			enabled: false
		},
		{
			title: 'Metaattach',
			url: '/metattach',
			icon: 'assets/svgs/header/clip.svg',
			enabled: false
		},
		{
			title: 'Suite 16 Categories',
			url: '/suite16categories',
			icon: 'assets/svgs/header/suite.svg',
			enabled: false
		},
		{
			title: 'Short Lists',
			url: '/shortlists',
			icon: 'assets/svgs/header/shortlist.svg',
			enabled: false
		},
		{
			title: 'Partners',
			url: '/partners',
			icon: 'assets/svgs/header/users.svg',
			enabled: false
		},
	];

	@HostListener('window:unload', ['$event'])
	clearLocalStorage(event: Event): void {
		localStorage.clear();
		sessionStorage.clear();
		this.storgeService.clear();
	}

	constructor(private platform: Platform,
		private splashScreen: SplashScreen,
		private statusBar: StatusBar,
		private router: Router,
		private shareService: SharedService,
		private logoutService: LogoutService,
		public accountService: AccountService,
		private storgeService: Storage) {
		this.initializeApp();
	}

	ngOnInit() {
		localStorage.clear();
		sessionStorage.clear();
		this.storgeService.clear();

		this.logoutService.isAuthcate$.subscribe((value) => {
			this.isAuthenticated = value ? true : false;

			if (value) {
				this.accountService.getUser().then((user: any) => {
					this.userDetails = user;
				});
			}
		});
	}

	logoutShow(isShow) {
		this.logoutpopover = isShow;
	}

	initializeApp() {
		this.platform.ready().then(() => {
			this.statusBar.styleDefault();
			this.splashScreen.hide();
			initializeApp(environment?.firebaseConfig);
			this.openMenu(window.location.pathname, false);

			this.router.events.subscribe(event => {
				if (event instanceof NavigationEnd) {
					this.openMenu(window.location.pathname, false);
				}
			});

			window.addEventListener('popstate', (event) => {
				// Handle the event here
				alert(`user navigated back to ${window.location.pathname}`);
				console.log(event);

				// Get the URL parameters
				const urlParams = new URLSearchParams(window.location.search);

				console.log(urlParams);

				// Access and log the specific parameter values
				//const param1 = urlParams.get('param1');
				//const param2 = urlParams.get('param2');
				//console.log('param1:', param1);
				//console.log('param2:', param2);
			});
		});
	}

	openMenu(selectedPath: string, isNavigate = true) {
		this.isShowSideMenu = selectedPath.includes('home') ? false : true;

		if (this.isShowSideMenu) {
			this.menuItems.forEach(menuItem => {
				menuItem.enabled = menuItem.url == selectedPath ? true : false;
			});

			if (isNavigate) {
				this.router.navigateByUrl(selectedPath);
			}
		}
		this.shareService.spinnerLoading().subscribe((res) => {
			if (!res) return
			this.spinnerText = res?.text ? res?.text : 'loading...';
			this.loadingVisible = res?.isLoading
		})
	}

	toggleSideMenu() {
		this.menu.toggle();

		if (this.platform.width() >= 992) {
			this.isSidebarCollapsed = !this.isSidebarCollapsed;
			console.log("this.isSidebarCollapsed", this.isSidebarCollapsed);
		}
	}

	isToggleSidnavbar(isToggle) {
		this.isCollaps = isToggle;
	}

	logout() {
		console.log('a: 2');
		this.shareService.logout();
		localStorage.clear();
		localStorage.removeItem('homeazzon_backoffice_AuthToken');
		//localStorage.removeItem('homeazzon_backoffice_token_type');
		localStorage.removeItem('homeazzon_backoffice_isLoggedIn');
		//localStorage.removeItem('homeazzon_backoffice_expiration_time');
		//localStorage.removeItem('homeazzon_backoffice_expires_in');
		this.logoutService._isAuthcate.next(false);
		this.logoutpopover = false;
		this.storgeService.clear();

		this.router.navigate(['home']);
	}
}
